import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import Disposisi from '../../../utilities/Disposisi';
import TransaksiService from '../../../services/transaksi/TransaksiService';
import SweetAlert from 'react-bootstrap-sweetalert';
import { formatDateString, getCurrentDateFormatted, romanNum } from '../../../utilities/Utils';
import MasterService from '../../../services/master/MasterService';
import UserService from '../../../services/user/UserService';
import PbUmkuService from '../../../services/pbumku/PbumkuService';

const ModalProses = ({ showAddProses, handleCloseAddProses, dataDisposisi, datappm, reloadList }) => {
    // console.log(datappm)
    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const [showProsesSuccess, setShowProsesSucces] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)
    const [rowData, setRowData] = useState(null)

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [negPartner, setNegPartner] = useState(null)
    const [jnsKomoditi, setJnsKomoditi] = useState(null)
    const [maksudKegiatan, setMaksudKegiatan] = useState(null)
    const [upt, setUpt] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)
    // let navigate = useNavigate()
    useEffect(() => {
        if (!datappm) return
        const fetchRef = async () => {
            try {
                const resNegTujuan = await masterService.getNegaraById(datappm.negaraPartner)
                setNegPartner(resNegTujuan.data.uraianNegara)

                const resJenisKomoditi = await masterService.getJenisKomoditiById(datappm.jenisKomoditi)
                setJnsKomoditi(resJenisKomoditi.data.jenisKomoditi)

                const resMaksud = await masterService.getMaksudPengirimanById(datappm.maksudKegiatan)
                setMaksudKegiatan(resMaksud.data.maksudPengiriman)

                const resUpt = await userService.getUptById(datappm.kdUpt)
                setUpt(resUpt.data.nmUnit)

            } catch (error) {
                setNegPartner(null)
                setJnsKomoditi(null)
                setMaksudKegiatan(null)
            }
        }
        fetchRef()
    }, [datappm, masterService, userService])

    const ProsesDisposisi = (dataPenugasan) => {
        setShowConfirmProses(true)
        setRowData(dataPenugasan)
    }

    const handleClickProses = async () => {
        setLoadingSave(true)
        try {
            // console.log(rowData)
            let jsonSppEvp = {
                idDisposisi: 2,
                nomorAju: datappm.nomorAju
            }
            let jsonppm = { ...datappm, status: '020' }

            const respNomor = await pbumkuService.ambilNomorService('PPM_PROSES', datappm.kdUpt, currentYear, localStorage.getItem('username'))
            // let noSuratTugasTemp = datappm.kdUpt + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + Math.floor(100000 + Math.random() * 900000)
            let noSuratTugasTemp = respNomor.data.uraianPusat + '/' + respNomor.data.kodePusat + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut
            // let jsonProses = { ...rowData, noTugas: 'PPM/E/' + noSuratTugasTemp, tglTugas: getCurrentDateFormatted(), createdBy: localStorage.getItem("userId") }
            let jsonProses = { ...rowData, noTugas: noSuratTugasTemp, tglTugas: getCurrentDateFormatted(), createdBy: localStorage.getItem("userId") }

            const response = await transaksiService.addPenugasan(jsonSppEvp)
            if (response.data.kode === '200') {
                setShowProsesSucces(true)
                setShowConfirmProses(false)

                await transaksiService.addPpm(jsonppm)

                // let jsonSppDraftHC = {
                //     idDisposisi: 4,
                //     nomorAju: datappm.nomorAju
                // }
                // await transaksiService.addPenugasan(jsonSppDraftHC)
                await transaksiService.addPenugasan(jsonProses)

                let dataStatus = {
                    nomorAju: datappm.nomorAju,
                    kodeStatus: '020',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('username')
                }
                await transaksiService.addPpmStatus(JSON.stringify(dataStatus))
            } else {
                setShowProsesFailed(true)
            }
        } catch (error) {
            console.log(error)
            setShowProsesFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickProsesSuccess = () => {
        setShowProsesSucces(false)
        setShowConfirmProses(false)
        handleCloseAddProses()
        // setShowAddProses(false)
        // window.location.reload()
        // refresh()
        // navigate('/penugasan/daftar')
        reloadList(datappm.nomorAju, 0, 10)
    }

    const handleClickProsesFailed = () => {
        setShowProsesFailed(false)
    }

    return (
        <>
            <Modal show={showAddProses}
                onHide={handleCloseAddProses}
                backdrop='static'
                keyboard={false}
                size="lg"
                centered
            >
                <Modal.Header>
                    <Modal.Title><h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <div className='col-4'>
                            <label className="col-sm-6 col-form-label-sm">Nomor Aju</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                            </div>
                        </div>
                        <div className='col-4'>
                            <label className="col-sm-6 col-form-label-sm">Tanggal Aju</label>
                            <div className="col-sm-6">
                                <input type="text" className="col-sm-12 form-control-sm" name="tanggal_aju" defaultValue={formatDateString(datappm.tanggalAju)} readOnly />
                            </div>
                        </div>
                        <div className='col-4'>
                            <label className="col-sm-6 col-form-label-sm">Tanggal Ekspor</label>
                            <div className="col-sm-6">
                                <input type="text" className="col-sm-12 form-control-sm" name="tanggal_aju" defaultValue={formatDateString(datappm.tanggalTibaBerangkat)} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-12'>
                            <label className="col-sm-4 col-form-label-sm">UPT</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={upt} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-6'>
                            <label className="col-sm-4 col-form-label-sm">Pengirim</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.namaTrader} readOnly />
                            </div>
                        </div>
                        <div className='col-6'>
                            <label className="col-sm-4 col-form-label-sm">Penerima</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="tanggal_aju" defaultValue={datappm.namaPartner} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-4'>
                            <label className="col-sm-4 col-form-label-sm">Jenis Komoditi</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={jnsKomoditi} readOnly />
                            </div>
                        </div>
                        <div className='col-4'>
                            <label className="col-sm-4 col-form-label-sm">Maksud Kegiatan</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={maksudKegiatan} readOnly />
                            </div>
                        </div>
                        <div className='col-4'>
                            <label className="col-sm-4 col-form-label-sm">Negara Tujuan</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={negPartner} readOnly />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => ProsesDisposisi(dataDisposisi)}>Proses</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseAddProses}>Batal</Button>
                </Modal.Footer>
            </Modal>

            {
                showConfirmProses &&
                <SweetAlert
                    title="Proses?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    title="Proses Berhasil"
                    success
                    onConfirm={handleClickProsesSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    title="Proses Gagal"
                    danger
                    onConfirm={handleClickProsesFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalProses